// A handful of exterior photos per brand+model (for the hero + thumbnail-strip gallery),
// hotlinked directly from Wikimedia Commons (not re-hosted) - see
// backend/src/carImages/match-model-images-gallery.js, which fetched and license-checked these
// via the Commons API, and was then hand-spot-checked to drop a couple of category-noise results
// (police/emergency-vehicle photos incidentally filed under "BMW X5"). Keyed the same way as
// mobile_mappings.ts (uppercase/underscore brand+model codes) so lookups go through the same
// findBrandKey/findModelKey resolution as everything else.
//
// Initial hand-picked set covering the homepage's "Most researched cars" cards plus a couple of
// others exercised during development - not yet run across the full catalog.

export interface CarImage {
  url: string;
  thumbUrl: string;
  pageUrl: string;
  artist: string;
  license: string;
}

export const CAR_IMAGES: { [brandKey: string]: { [modelKey: string]: CarImage[] } } = {
  BMW: {
    M3: [
      {
        url: 'https://upload.wikimedia.org/wikipedia/commons/a/a8/064_-_BMW_M3_-_Flickr_-_Price-Photography.jpg',
        thumbUrl:
          'https://upload.wikimedia.org/wikipedia/commons/thumb/a/a8/064_-_BMW_M3_-_Flickr_-_Price-Photography.jpg/960px-064_-_BMW_M3_-_Flickr_-_Price-Photography.jpg',
        pageUrl: 'https://commons.wikimedia.org/wiki/File:064_-_BMW_M3_-_Flickr_-_Price-Photography.jpg',
        artist: 'Michael Price from Houston, USA',
        license: 'CC BY 2.0',
      },
      {
        url: 'https://upload.wikimedia.org/wikipedia/commons/b/b0/065_-_BMW_M3_-_Flickr_-_Price-Photography.jpg',
        thumbUrl:
          'https://upload.wikimedia.org/wikipedia/commons/thumb/b/b0/065_-_BMW_M3_-_Flickr_-_Price-Photography.jpg/960px-065_-_BMW_M3_-_Flickr_-_Price-Photography.jpg',
        pageUrl: 'https://commons.wikimedia.org/wiki/File:065_-_BMW_M3_-_Flickr_-_Price-Photography.jpg',
        artist: 'Michael Price from Houston, USA',
        license: 'CC BY 2.0',
      },
      {
        url: 'https://upload.wikimedia.org/wikipedia/commons/2/27/066_-_BMW_M3_-_Flickr_-_Price-Photography.jpg',
        thumbUrl:
          'https://upload.wikimedia.org/wikipedia/commons/thumb/2/27/066_-_BMW_M3_-_Flickr_-_Price-Photography.jpg/960px-066_-_BMW_M3_-_Flickr_-_Price-Photography.jpg',
        pageUrl: 'https://commons.wikimedia.org/wiki/File:066_-_BMW_M3_-_Flickr_-_Price-Photography.jpg',
        artist: 'Michael Price from Houston, USA',
        license: 'CC BY 2.0',
      },
      {
        url: 'https://upload.wikimedia.org/wikipedia/commons/d/d5/073_-_BMW_M3_-_Flickr_-_Price-Photography.jpg',
        thumbUrl:
          'https://upload.wikimedia.org/wikipedia/commons/thumb/d/d5/073_-_BMW_M3_-_Flickr_-_Price-Photography.jpg/960px-073_-_BMW_M3_-_Flickr_-_Price-Photography.jpg',
        pageUrl: 'https://commons.wikimedia.org/wiki/File:073_-_BMW_M3_-_Flickr_-_Price-Photography.jpg',
        artist: 'Michael Price from Houston, USA',
        license: 'CC BY 2.0',
      },
      {
        url: 'https://upload.wikimedia.org/wikipedia/commons/a/a7/074_-_BMW_M3_-_Flickr_-_Price-Photography.jpg',
        thumbUrl:
          'https://upload.wikimedia.org/wikipedia/commons/thumb/a/a7/074_-_BMW_M3_-_Flickr_-_Price-Photography.jpg/960px-074_-_BMW_M3_-_Flickr_-_Price-Photography.jpg',
        pageUrl: 'https://commons.wikimedia.org/wiki/File:074_-_BMW_M3_-_Flickr_-_Price-Photography.jpg',
        artist: 'Michael Price from Houston, USA',
        license: 'CC BY 2.0',
      },
      {
        url: 'https://upload.wikimedia.org/wikipedia/commons/4/4f/1200_hv_bmw_m3-Omistaja_Tuomas_Kuurne_2014-06-12_09-23.jpg',
        thumbUrl:
          'https://upload.wikimedia.org/wikipedia/commons/thumb/4/4f/1200_hv_bmw_m3-Omistaja_Tuomas_Kuurne_2014-06-12_09-23.jpg/960px-1200_hv_bmw_m3-Omistaja_Tuomas_Kuurne_2014-06-12_09-23.jpg',
        pageUrl: 'https://commons.wikimedia.org/wiki/File:1200_hv_bmw_m3-Omistaja_Tuomas_Kuurne_2014-06-12_09-23.jpg',
        artist: 'User:Tammitynnyri',
        license: 'CC BY-SA 3.0',
      },
    ],
    X5: [
      {
        url: 'https://upload.wikimedia.org/wikipedia/commons/a/ab/Moscow%2C_BMW_X5_black%2C_May_2026_01.jpg',
        thumbUrl:
          'https://upload.wikimedia.org/wikipedia/commons/thumb/a/ab/Moscow%2C_BMW_X5_black%2C_May_2026_01.jpg/960px-Moscow%2C_BMW_X5_black%2C_May_2026_01.jpg',
        pageUrl: 'https://commons.wikimedia.org/wiki/File:Moscow,_BMW_X5_black,_May_2026_01.jpg',
        artist: 'Retired electrician',
        license: 'CC0',
      },
      {
        url: 'https://upload.wikimedia.org/wikipedia/commons/5/59/04-06_BMW_X5.jpg',
        thumbUrl: 'https://upload.wikimedia.org/wikipedia/commons/thumb/5/59/04-06_BMW_X5.jpg/960px-04-06_BMW_X5.jpg',
        pageUrl: 'https://commons.wikimedia.org/wiki/File:04-06_BMW_X5.jpg',
        artist: 'IFCAR',
        license: 'Public domain',
      },
      {
        url: 'https://upload.wikimedia.org/wikipedia/commons/5/54/00-03_BMW_X5.jpg',
        thumbUrl: 'https://upload.wikimedia.org/wikipedia/commons/thumb/5/54/00-03_BMW_X5.jpg/960px-00-03_BMW_X5.jpg',
        pageUrl: 'https://commons.wikimedia.org/wiki/File:00-03_BMW_X5.jpg',
        artist: 'IFCAR',
        license: 'Public domain',
      },
      {
        url: "https://upload.wikimedia.org/wikipedia/commons/6/6a/%2701-%2703_BMW_X5_3.0i.jpg",
        thumbUrl:
          "https://upload.wikimedia.org/wikipedia/commons/thumb/6/6a/%2701-%2703_BMW_X5_3.0i.jpg/960px-%2701-%2703_BMW_X5_3.0i.jpg",
        pageUrl: "https://commons.wikimedia.org/wiki/File:'01-'03_BMW_X5_3.0i.jpg",
        artist: 'Bull-Doser',
        license: 'Public domain',
      },
      {
        url: "https://upload.wikimedia.org/wikipedia/commons/6/68/%2704-%2706_BMW_X5.JPG",
        thumbUrl: "https://upload.wikimedia.org/wikipedia/commons/6/68/%2704-%2706_BMW_X5.JPG",
        pageUrl: "https://commons.wikimedia.org/wiki/File:'04-'06_BMW_X5.JPG",
        artist: 'Bull-Doser',
        license: 'Public domain',
      },
      {
        url: "https://upload.wikimedia.org/wikipedia/commons/b/b9/%2700-%2703_BMW_X5_4.4i.JPG",
        thumbUrl:
          "https://upload.wikimedia.org/wikipedia/commons/thumb/b/b9/%2700-%2703_BMW_X5_4.4i.JPG/960px-%2700-%2703_BMW_X5_4.4i.JPG",
        pageUrl: "https://commons.wikimedia.org/wiki/File:'00-'03_BMW_X5_4.4i.JPG",
        artist: 'Bull-Doser',
        license: 'Public domain',
      },
    ],
    M6: [
      {
        url: 'https://upload.wikimedia.org/wikipedia/commons/b/b3/BMW_M6_Photography_by_David_Adam_Kess.jpg',
        thumbUrl:
          'https://upload.wikimedia.org/wikipedia/commons/thumb/b/b3/BMW_M6_Photography_by_David_Adam_Kess.jpg/960px-BMW_M6_Photography_by_David_Adam_Kess.jpg',
        pageUrl: 'https://commons.wikimedia.org/wiki/File:BMW_M6_Photography_by_David_Adam_Kess.jpg',
        artist: 'David Adam Kess',
        license: 'CC BY-SA 4.0',
      },
      {
        url: 'https://upload.wikimedia.org/wikipedia/commons/e/ec/BMW_---M_Family_%2814622168226%29.jpg',
        thumbUrl:
          'https://upload.wikimedia.org/wikipedia/commons/thumb/e/ec/BMW_---M_Family_%2814622168226%29.jpg/960px-BMW_---M_Family_%2814622168226%29.jpg',
        pageUrl: 'https://commons.wikimedia.org/wiki/File:BMW_---M_Family_(14622168226).jpg',
        artist: 'Falcon® Photography from France',
        license: 'CC BY-SA 2.0',
      },
      {
        url: 'https://upload.wikimedia.org/wikipedia/commons/5/5a/1986_BMW_M6.jpg',
        thumbUrl: 'https://upload.wikimedia.org/wikipedia/commons/thumb/5/5a/1986_BMW_M6.jpg/960px-1986_BMW_M6.jpg',
        pageUrl: 'https://commons.wikimedia.org/wiki/File:1986_BMW_M6.jpg',
        artist: 'Jlantzy (Jamie Lantzy)',
        license: 'CC BY 2.5',
      },
      {
        url: 'https://upload.wikimedia.org/wikipedia/commons/2/24/1986.BMW-M6-2.jpg',
        thumbUrl:
          'https://upload.wikimedia.org/wikipedia/commons/thumb/2/24/1986.BMW-M6-2.jpg/960px-1986.BMW-M6-2.jpg',
        pageUrl: 'https://commons.wikimedia.org/wiki/File:1986.BMW-M6-2.jpg',
        artist: 'Jlantzy (Jamie Lantzy)',
        license: 'CC BY 2.5',
      },
      {
        url: 'https://upload.wikimedia.org/wikipedia/commons/6/66/1988_BMW_M6_-_Crab_Flats.jpg',
        thumbUrl:
          'https://upload.wikimedia.org/wikipedia/commons/thumb/6/66/1988_BMW_M6_-_Crab_Flats.jpg/960px-1988_BMW_M6_-_Crab_Flats.jpg',
        pageUrl: 'https://commons.wikimedia.org/wiki/File:1988_BMW_M6_-_Crab_Flats.jpg',
        artist: 'Schanzeml',
        license: 'CC BY-SA 4.0',
      },
    ],
  },
  MERCEDES_BENZ: {
    C_CLASS: [
      {
        url: "https://upload.wikimedia.org/wikipedia/commons/c/c5/%2797-%2700_Mercedes-Benz_C-Class.JPG",
        thumbUrl: "https://upload.wikimedia.org/wikipedia/commons/c/c5/%2797-%2700_Mercedes-Benz_C-Class.JPG",
        pageUrl: "https://commons.wikimedia.org/wiki/File:'97-'00_Mercedes-Benz_C-Class.JPG",
        artist: 'Bull-Doser',
        license: 'Public domain',
      },
      {
        url: "https://upload.wikimedia.org/wikipedia/commons/0/01/%2793-%2796_Mercedes-Benz_C-Class_Sedan_%28Orange_Julep%29.jpg",
        thumbUrl:
          "https://upload.wikimedia.org/wikipedia/commons/thumb/0/01/%2793-%2796_Mercedes-Benz_C-Class_Sedan_%28Orange_Julep%29.jpg/960px-%2793-%2796_Mercedes-Benz_C-Class_Sedan_%28Orange_Julep%29.jpg",
        pageUrl: "https://commons.wikimedia.org/wiki/File:'93-'96_Mercedes-Benz_C-Class_Sedan_(Orange_Julep).jpg",
        artist: 'Bull-Doser',
        license: 'Public domain',
      },
      {
        url: "https://upload.wikimedia.org/wikipedia/commons/8/80/%2797-%2700_Mercedes-Benz_C-Class_%28Orange_Julep_%2710%29.jpg",
        thumbUrl:
          "https://upload.wikimedia.org/wikipedia/commons/thumb/8/80/%2797-%2700_Mercedes-Benz_C-Class_%28Orange_Julep_%2710%29.jpg/960px-%2797-%2700_Mercedes-Benz_C-Class_%28Orange_Julep_%2710%29.jpg",
        pageUrl: "https://commons.wikimedia.org/wiki/File:'97-'00_Mercedes-Benz_C-Class_(Orange_Julep_'10).jpg",
        artist: 'Bull-Doser',
        license: 'Public domain',
      },
      {
        url: "https://upload.wikimedia.org/wikipedia/commons/8/81/%2797_Mercedes-Benz_C280_%28Toronto_Spring_%2712_Classic_Car_Auction%29.JPG",
        thumbUrl:
          "https://upload.wikimedia.org/wikipedia/commons/thumb/8/81/%2797_Mercedes-Benz_C280_%28Toronto_Spring_%2712_Classic_Car_Auction%29.JPG/960px-%2797_Mercedes-Benz_C280_%28Toronto_Spring_%2712_Classic_Car_Auction%29.JPG",
        pageUrl:
          "https://commons.wikimedia.org/wiki/File:'97_Mercedes-Benz_C280_(Toronto_Spring_'12_Classic_Car_Auction).JPG",
        artist: 'Bull-Doser at English Wikipedia',
        license: 'Public domain',
      },
      {
        url: 'https://upload.wikimedia.org/wikipedia/commons/a/a4/1994_Mercedes-Benz_C_180_%28W_202%29_Classic_sedan_%282015-06-15%29_01.jpg',
        thumbUrl:
          'https://upload.wikimedia.org/wikipedia/commons/thumb/a/a4/1994_Mercedes-Benz_C_180_%28W_202%29_Classic_sedan_%282015-06-15%29_01.jpg/960px-1994_Mercedes-Benz_C_180_%28W_202%29_Classic_sedan_%282015-06-15%29_01.jpg',
        pageUrl: 'https://commons.wikimedia.org/wiki/File:1994_Mercedes-Benz_C_180_(W_202)_Classic_sedan_(2015-06-15)_01.jpg',
        artist: 'OSX',
        license: 'Public domain',
      },
      {
        url: 'https://upload.wikimedia.org/wikipedia/commons/f/fc/1994_Mercedes-Benz_C_180_%28W_202%29_Classic_sedan_%282015-06-15%29_02.jpg',
        thumbUrl:
          'https://upload.wikimedia.org/wikipedia/commons/thumb/f/fc/1994_Mercedes-Benz_C_180_%28W_202%29_Classic_sedan_%282015-06-15%29_02.jpg/960px-1994_Mercedes-Benz_C_180_%28W_202%29_Classic_sedan_%282015-06-15%29_02.jpg',
        pageUrl: 'https://commons.wikimedia.org/wiki/File:1994_Mercedes-Benz_C_180_(W_202)_Classic_sedan_(2015-06-15)_02.jpg',
        artist: 'OSX',
        license: 'Public domain',
      },
    ],
  },
  AUDI: {
    RS4: [
      {
        url: 'https://upload.wikimedia.org/wikipedia/commons/9/93/2001_Audi_RS_4_%288D%29_quattro_Avant_station_wagon_%282012-12-10%29_02.jpg',
        thumbUrl:
          'https://upload.wikimedia.org/wikipedia/commons/thumb/9/93/2001_Audi_RS_4_%288D%29_quattro_Avant_station_wagon_%282012-12-10%29_02.jpg/960px-2001_Audi_RS_4_%288D%29_quattro_Avant_station_wagon_%282012-12-10%29_02.jpg',
        pageUrl:
          'https://commons.wikimedia.org/wiki/File:2001_Audi_RS_4_(8D)_quattro_Avant_station_wagon_(2012-12-10)_02.jpg',
        artist: 'FotoSleuth',
        license: 'CC BY 2.0',
      },
      {
        url: 'https://upload.wikimedia.org/wikipedia/commons/2/2e/2001_Audi_RS4_B5_Avant_-_Flickr_-_The_Car_Spy_%281%29.jpg',
        thumbUrl:
          'https://upload.wikimedia.org/wikipedia/commons/thumb/2/2e/2001_Audi_RS4_B5_Avant_-_Flickr_-_The_Car_Spy_%281%29.jpg/960px-2001_Audi_RS4_B5_Avant_-_Flickr_-_The_Car_Spy_%281%29.jpg',
        pageUrl: 'https://commons.wikimedia.org/wiki/File:2001_Audi_RS4_B5_Avant_-_Flickr_-_The_Car_Spy_(1).jpg',
        artist: 'The Car Spy',
        license: 'CC BY 2.0',
      },
      {
        url: 'https://upload.wikimedia.org/wikipedia/commons/3/32/2001_Audi_RS4_B5_Avant_-_Flickr_-_The_Car_Spy_%2810%29.jpg',
        thumbUrl:
          'https://upload.wikimedia.org/wikipedia/commons/thumb/3/32/2001_Audi_RS4_B5_Avant_-_Flickr_-_The_Car_Spy_%2810%29.jpg/960px-2001_Audi_RS4_B5_Avant_-_Flickr_-_The_Car_Spy_%2810%29.jpg',
        pageUrl: 'https://commons.wikimedia.org/wiki/File:2001_Audi_RS4_B5_Avant_-_Flickr_-_The_Car_Spy_(10).jpg',
        artist: 'The Car Spy',
        license: 'CC BY 2.0',
      },
      {
        url: 'https://upload.wikimedia.org/wikipedia/commons/6/69/2001_Audi_RS4_B5_Avant_-_Flickr_-_The_Car_Spy_%2811%29.jpg',
        thumbUrl:
          'https://upload.wikimedia.org/wikipedia/commons/thumb/6/69/2001_Audi_RS4_B5_Avant_-_Flickr_-_The_Car_Spy_%2811%29.jpg/960px-2001_Audi_RS4_B5_Avant_-_Flickr_-_The_Car_Spy_%2811%29.jpg',
        pageUrl: 'https://commons.wikimedia.org/wiki/File:2001_Audi_RS4_B5_Avant_-_Flickr_-_The_Car_Spy_(11).jpg',
        artist: 'The Car Spy',
        license: 'CC BY 2.0',
      },
      {
        url: 'https://upload.wikimedia.org/wikipedia/commons/a/a6/2001_Audi_RS4_B5_Avant_-_Flickr_-_The_Car_Spy_%2812%29.jpg',
        thumbUrl:
          'https://upload.wikimedia.org/wikipedia/commons/thumb/a/a6/2001_Audi_RS4_B5_Avant_-_Flickr_-_The_Car_Spy_%2812%29.jpg/960px-2001_Audi_RS4_B5_Avant_-_Flickr_-_The_Car_Spy_%2812%29.jpg',
        pageUrl: 'https://commons.wikimedia.org/wiki/File:2001_Audi_RS4_B5_Avant_-_Flickr_-_The_Car_Spy_(12).jpg',
        artist: 'The Car Spy',
        license: 'CC BY 2.0',
      },
      {
        url: 'https://upload.wikimedia.org/wikipedia/commons/f/f3/2001_Audi_RS4_B5_Avant_-_Flickr_-_The_Car_Spy_%2813%29.jpg',
        thumbUrl:
          'https://upload.wikimedia.org/wikipedia/commons/thumb/f/f3/2001_Audi_RS4_B5_Avant_-_Flickr_-_The_Car_Spy_%2813%29.jpg/960px-2001_Audi_RS4_B5_Avant_-_Flickr_-_The_Car_Spy_%2813%29.jpg',
        pageUrl: 'https://commons.wikimedia.org/wiki/File:2001_Audi_RS4_B5_Avant_-_Flickr_-_The_Car_Spy_(13).jpg',
        artist: 'The Car Spy',
        license: 'CC BY 2.0',
      },
    ],
  },
};
